import React, { ReactElement } from 'react';

const ChevronLeft = (): ReactElement => (
    <path fillRule="evenodd" clipRule="evenodd" d="M46.0305 1.25526C47.7041 2.92893 47.7041 5.6425 46.0305 7.31617L23.3466 30L46.0305 52.6838C47.7041 54.3575 47.7041 57.0711 46.0305 58.7447C44.3568 60.4184 41.6432 60.4184 39.9695 58.7447L14.2553 33.0305C12.5816 31.3568 12.5816 28.6432 14.2553 26.9695L39.9695 1.25526C41.6432 -0.418419 44.3568 -0.418419 46.0305 1.25526Z" />
);

export default ChevronLeft;
